import React from 'react';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from 'components/buttons/DeleteButton';
import { useTranslation } from 'react-i18next';

const formatTimeForInput = (value) => {
    if (!value) return '';
    return String(value).substring(0, 5);
};

const BreaksInput = ({ value = [], onChange, readOnly = false }) => {
    const { t } = useTranslation();
    const breaks = Array.isArray(value) ? value : [];

    const updateBreaks = (nextBreaks) => {
        onChange({ target: { value: nextBreaks } });
    };

    const handleBreakChange = (index, field, fieldValue) => {
        const nextBreaks = breaks.map((item, itemIndex) => (
            itemIndex === index ? { ...item, [field]: fieldValue } : item
        ));
        updateBreaks(nextBreaks);
    };

    const handleAdd = () => {
        updateBreaks([...breaks, { start: '12:00', end: '13:00' }]);
    };

    const handleRemove = (index) => {
        const nextBreaks = [...breaks];
        nextBreaks.splice(index, 1);
        updateBreaks(nextBreaks);
    };

    return (
        <div className="scheduler-breaks">
            {breaks.map((item, index) => (
                <FormGroup key={`${index}-${item.start}-${item.end}`}>
                    <Row className="align-items-center g-2">
                        <Col md={4}>
                            <Input
                                type="time"
                                value={formatTimeForInput(item.start)}
                                onChange={(event) => handleBreakChange(index, 'start', event.target.value)}
                                readOnly={readOnly}
                            />
                        </Col>
                        <Col md={1} className="text-center">
                            {t('schedulers.input.breakTo')}
                        </Col>
                        <Col md={4}>
                            <Input
                                type="time"
                                value={formatTimeForInput(item.end)}
                                onChange={(event) => handleBreakChange(index, 'end', event.target.value)}
                                readOnly={readOnly}
                            />
                        </Col>
                        <Col md={2}>
                            {!readOnly && <DeleteButton deleteItem={handleRemove} id={index} />}
                        </Col>
                    </Row>
                </FormGroup>
            ))}
            {!readOnly && (
                <Button color="secondary" size="sm" onClick={handleAdd}>
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                </Button>
            )}
        </div>
    );
};

export default BreaksInput;
